export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'Klucz API',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    error: 'Nie udało się zapisać zmian',
    success: 'Zmiany zostały zapisane',
  },
  connected: {
    title: 'ExpertOrder jest połączony',
    description: 'Ta integracja jest skonfigurowana.',
  },
};
